import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import Snackbar1 from "../../Common/snackbar/components/snackbar";
import { hasSubmittedToday, markSubmittedToday, DUPLICATE_LEAD_MESSAGE } from "../leadDedupe";

export default function ShowInterest({
  kepInTouch,
  someValue,
  snackbar,
  close_snack_bar,
}) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [pincode, setPincode] = useState("");
  const [dealer, setDealer] = useState("");
  const [consentChecked, setConsentChecked] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    const mobileRegex = /^[6-9]\d{9}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!firstName) newErrors.firstName = "First Name is required.";
    if (!lastName) newErrors.lastName = "Last Name is required.";
    if (!mobile) newErrors.mobile = "Mobile number is required";
    else if (!mobileRegex.test(mobile))
      newErrors.mobile = "Enter a valid 10-digit mobile number";
    if (!email) newErrors.email = "Email is required";
    else if (!emailRegex.test(email))
      newErrors.email = "Enter a valid email address";
    if (!dealer) newErrors.dealer = "Please select your Showroom Location.";
    if (!consentChecked) newErrors.consentChecked = "Consent is required.";
    if (mobileRegex.test(mobile) && hasSubmittedToday(mobile))
      newErrors.mobile = DUPLICATE_LEAD_MESSAGE;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (submitting) return;
    if (validateForm()) {
      setSubmitting(true);
      kepInTouch(
        firstName,
        lastName,
        mobile,
        email,
        pincode,
        dealer,
        consentChecked,
        someValue
      );
      markSubmittedToday(mobile);
      setFirstName("");
      setLastName("");
      setMobile("");
      setEmail("");
      setPincode("");
      setDealer("");
      setConsentChecked(false);
      setErrors({});
      setTimeout(() => setSubmitting(false), 3500);
    }
  };

  return (
    <div
      style={{
        padding: "2% 6%",
        backgroundColor: "rgba(0, 0, 0, 0.1)",
      }}
    >
      <Typography
        fontFamily="KIAbodyLatinbasic_Bold"
        sx={{ fontSize: "clamp(24px, 4vw, 30px)" }}
      >
        Show Interest
      </Typography>

      <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit}>
        {/* Input Container */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "24px",
            padding: "24px 0",
          }}
        >
          {[
            {
              label: "First Name",
              type: "text",
              value: firstName,
              setValue: setFirstName,
              name: "firstName",
            },
            {
              label: "Last Name",
              type: "text",
              value: lastName,
              setValue: setLastName,
              name: "lastName",
            },
            {
              label: "Mobile Number",
              type: "tel",
              value: mobile,
              setValue: setMobile,
              name: "mobile",
            },
            {
              label: "Email",
              type: "email",
              value: email,
              setValue: setEmail,
              name: "email",
              placeholder: "name@example.com",
            },
            {
              label: "Pincode",
              type: "number",
              value: pincode,
              setValue: setPincode,
              name: "pincode",
            },
          ].map(({ label, type, value, setValue, name, placeholder }) => (
            <div
              key={name}
              style={{
                flex: "1 1 calc(50% - 24px)",
                minWidth: "280px",
              }}
            >
              <TextField
                variant="standard"
                label={label}
                type={type}
                fullWidth
                value={value}
                onChange={(e) => setValue(e.target.value)}
                error={!!errors[name]}
                helperText={errors[name] || ""}
                placeholder={placeholder}
                InputProps={{
                  style: { paddingTop: "7px", paddingBottom: "7px" },
                }}
              />
            </div>
          ))}

          {/* Dealer Dropdown */}
          <div style={{ flex: "1 1 calc(50% - 24px)", minWidth: "280px" }}>
            <TextField
              variant="standard"
              label="Select Showroom Location"
              select
              fullWidth
              value={dealer}
              onChange={(e) => setDealer(e.target.value)}
              error={!!errors.dealer}
              helperText={errors.dealer || ""}
            >
              {[
                "Angul",
                "Berhampur",
                "Bhubaneswar",
                "Cuttack",
                "Jajpur",
                "Jharsuguda",
                "Sambalpur",
              ].map((dealer) => (
                <MenuItem
                  key={dealer.toLowerCase()}
                  value={dealer.toLowerCase()}
                >
                  {dealer}
                </MenuItem>
              ))}
            </TextField>
          </div>
        </div>

        {/* Consent Checkbox */}
        <div style={{ marginTop: "12px" }}>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={consentChecked}
                onChange={(e) => setConsentChecked(e.target.checked)}
              />
            }
            label="I authorize Central Kia to save my contact details.*"
            sx={{
              "& .MuiTypography-root": {
                fontSize: "12px",
                fontFamily: "KIAbodyLatinbasic_Regular",
                color: errors.consentChecked ? "red" : "#555",
              },
            }}
          />
          {errors.consentChecked && (
            <Typography variant="caption" color="error">
              {errors.consentChecked}
            </Typography>
          )}
        </div>

        {/* Submit Button */}
        <div
          style={{
            marginTop: "20px",
            maxWidth: "250px",
          }}
        >
          <Button
            fullWidth
            variant="contained"
            sx={{
              color: "#FFF",
              backgroundColor: consentChecked ? "black" : "#91999d",
              textTransform: "capitalize",
              fontSize: { xs: "14px", md: "16px" },
              borderRadius: 0,
              fontWeight: 600,
              "&:hover": {
                backgroundColor: consentChecked ? "#91999d" : "#91999d",
              },
            }}
            type="submit"
            disabled={submitting}
          >
            {submitting ? "Submitting..." : "Submit"}
          </Button>
        </div>
      </Box>

      <Snackbar1
        open={snackbar.response_received}
        message={snackbar.message}
        close_snack_bar={close_snack_bar}
      />
    </div>
  );
}
